/*
 * @Author: wuyanbin beijingwyb@163.com
 * @Date: 2019-12-03 10:41:13
 * @Last Modified by: wuyanbin beijingwyb@163.com
 * @Last Modified time: 2019-12-03 11:19:49
 */
import React, { Component } from 'react';
import { Button } from 'antd';
import style from './index.less';
class BtnFakeDisable extends Component {
    render() {
        const { btnType, btnFakeDisable, btnText } = this.props;
        return (<Button className={btnFakeDisable ? style.fake_btn_disable : ''} type={btnType} onClick={() => {
            this.props.onClick();
        }}>
                {btnText}
            </Button>);
    }
}
BtnFakeDisable.defaultProps = {
    btnType: 'primary',
    btnFakeDisable: false,
    btnText: '按钮',
};
export default BtnFakeDisable;
